import { useCallback } from 'react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { showConfirmDialog } from '../../../actions/messageDialog';
import { getTelex, showAttachment } from '../../../actions/telex';
import { useTelegramData } from './useTelegramData';

export const useTelegrams = () => {
    const dispatch = useDispatch();
    const { t: translate } = useTranslation();
    const {
        ofp,
        ofpRef,
        telegrams,
    } = useTelegramData();

    const handleShowConfirmDialog = useCallback(
        ({ title, message, btnCancelVisibility = true }) =>
            dispatch(
                showConfirmDialog({
                    title,
                    message,
                    btnCancelVisibility,
                })
            ),
        []
    );

    const handleClickOfp = useCallback(() => {
        if (ofpRef.current) {
            dispatch(getTelex({ id: ofpRef.current.telegramId, name: `OFP ${ofpRef.current.name}` }));
        } else {
            handleShowConfirmDialog({
                title: translate('warningMessage'),
                message: translate('messages.noSelectedCfpForAc'),
                btnCancelVisibility: false,
            });
        }
    }, [ofpRef]);

    const handleClickTelegram = useCallback(
        (code) => {
            const telegram = Object.keys(telegrams).reduce((res, key) => {
                if (telegrams[key] && key === code) {
                    const prevMailTime = get(res, 'mailTime');
                    const mailTime = get(telegrams[key], 'mailTime');
                    if (!res || (prevMailTime && mailTime && new Date(prevMailTime) < new Date(mailTime))) {
                        res = telegrams[key];
                    }
                }

                return res;
            }, null);

            if (telegram) {
                dispatch(getTelex({ id: telegram.id, name: telegram.name }));
            } else {
                handleShowConfirmDialog({
                    title: translate('warningMessage'),
                    message: translate('messages.noTelegramForAc', { code }),
                    btnCancelVisibility: false,
                });
            }
        },
        [telegrams]
    );

    const handleShowAttachment = useCallback((id) => dispatch(showAttachment(id)), []);

    return {
        telegrams,
        ofp,
        handleClickOfp,
        handleClickTelegram,
        handleShowAttachment,
    };
};
